// Centralized site content for lashliftvancouver.ca
export const SITE = {
  name: 'Lash Lift Vancouver',
  parent: 'Prép Beauty Parlour',
  tagline: 'Natural, lifted lashes that last 8–12 weeks.',
  address: {
    line1: '1305 Burrard Street',
    line2: 'Vancouver, BC V6Z 1Z7',
    neighbourhoods: 'West End · Yaletown · Davie Village',
  },
  phone: '604-764-6452',
  phoneHref: 'tel:+16047646452',
  email: 'info@prepbeautyparlour.com',
  hours: [
    { day: 'Monday – Friday', time: '10:00 AM — 7:00 PM' },
    { day: 'Saturday', time: '10:00 AM — 6:00 PM' },
    { day: 'Sunday', time: '11:00 AM — 6:00 PM' },
  ],
  booking: 'https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh',
  instagram: 'https://www.instagram.com/prepbeautyparlour',
  promoCode: 'PREP15',
  promoText: '15% off your first lash lift — use code PREP15',
  parentSite: 'https://prepbeautyparlour.com',
  mapsUrl: 'https://maps.app.goo.gl/Jj9UEbpqVN5eg2FR9',
};

export const STATS = [
  { value: '3,500+', label: '5-Star Reviews' },
  { value: '75 min', label: 'Session Time' },
  { value: 'From $125', label: 'Lift + Tint' },
  { value: '8–12 wks', label: 'Lasts' },
];

export const TREATMENTS = [
  {
    id: 'yumi',
    flag: '🇫🇷',
    badge: 'Bestseller · The Gold Standard',
    name: 'YUMI Keratin Lash Lift & Tint',
    blurb:
      'The gold standard of lash lifts. Developed in France, YUMI uses a keratin-infused formula to lift, strengthen and condition your lashes simultaneously — no harsh chemicals. Visibly longer, darker, healthier-looking lashes that last 8–12 weeks.',
    bullets: [
      { k: 'Best for', v: 'All lash types — especially fine or straight lashes' },
      { k: 'Duration', v: '75 minutes' },
      { k: 'Includes', v: 'Lift + tint' },
    ],
    price: '$150',
  },
  {
    id: 'inlei',
    flag: '🇮🇹',
    badge: 'The Gentle Alternative',
    name: 'InLei Lash Filler® & Tint',
    blurb:
      'A gentler, nourishing alternative made in Italy. InLei Lash Filler® is ideal for clients with fragile, over-processed or shorter lashes. The filler formula adds volume and conditioning while lifting — your lashes feel healthier after every treatment.',
    bullets: [
      { k: 'Best for', v: 'Sensitive eyes or fragile lashes' },
      { k: 'Duration', v: '75 minutes' },
      { k: 'Includes', v: 'Lift + tint' },
    ],
    price: '$125',
  },
];

export const COMPARISON_ROWS = [
  { feature: 'Origin', yumi: 'France', inlei: 'Italy' },
  { feature: 'Formula', yumi: 'Keratin-infused', inlei: 'Filler + conditioning' },
  { feature: 'Best for', yumi: 'All lash types', inlei: 'Fine / fragile lashes' },
  { feature: 'Lasts', yumi: '8–12 weeks', inlei: '6–8 weeks' },
  { feature: 'Price', yumi: '$150', inlei: '$125' },
];

export const PROCESS = [
  {
    n: '01',
    title: 'Consultation',
    time: '5 min',
    body:
      'We assess your natural lash length, curl, and health — and help you choose between YUMI and InLei based on what your lashes actually need.',
  },
  {
    n: '02',
    title: 'Cleanse & Prep',
    time: '10 min',
    body:
      'Your lashes are thoroughly cleansed and dried. A silicone shield is placed on your eyelid to shape the lift.',
  },
  {
    n: '03',
    title: 'The Lift',
    time: '45–50 min',
    body:
      'Lashes are carefully combed over the shield. Lifting and setting lotions are applied. For YUMI: the keratin treatment follows. For InLei: the filler formula volumizes and nourishes.',
  },
  {
    n: '04',
    title: 'Tint',
    time: '10 min',
    body:
      'A lash tint is applied to darken and define your lashes — no mascara needed for 6–8 weeks.',
  },
  {
    n: '05',
    title: 'Nourishing Finish',
    time: '—',
    body:
      'A conditioning serum is applied to lock in moisture and keep your lashes healthy between lifts.',
  },
];

export const PRICING = [
  { name: 'YUMI Lash Lift & Tint', duration: '75 min', price: '$150', popular: true },
  { name: 'InLei Lash Filler® & Tint', duration: '75 min', price: '$125', popular: true },
  { name: 'YUMI Lash Lift + Brow Tint & Lamination', duration: '80 min', price: '$225' },
  { name: 'YUMI Lash Lift + Brow Shaping, Tint & Lamination', duration: '90 min', price: '$225' },
  { name: 'Lash Lift Rehab | Lift Reversal', duration: '30 min', price: '$50' },
];

export const TEAM = [
  {
    id: 'roselyn',
    name: 'Roselyn',
    role: 'Master Lash & Brow Artist',
    rating: '4.9',
    bio:
      'A founding artist at Prép with over a decade of lash lift expertise. Specializes in tailoring YUMI and InLei treatments to every lash type and lifestyle.',
    specialties: ['YUMI Certified', 'Brow Lamination', 'Lash Lift'],
    img: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/83823/medium/d646374a-6679-4c63-ab9e-7e3f79929cd7-C757102E-7538-4C0B-B848-4792BC53D6A6.jpeg',
    book: 'https://fresha.com/p/roselyn-n-2978354',
  },
  {
    id: 'maryna',
    name: 'Maryna',
    role: 'Senior Lash & Brow Artist',
    rating: '5.0',
    bio:
      'Known across Vancouver for delicate, gentle hands and flawless lift correction. The artist clients trust when their lash lift needs to be perfect.',
    specialties: ['Lift Correction', 'YUMI Certified', 'InLei Certified'],
    img: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/1490679/medium/a80006c5-3627-47cd-8a30-f96ea24da51b-IMG_3725.jpeg',
    book: 'https://fresha.com/p/maryna-koicheva-5897618',
  },
  {
    id: 'miriam',
    name: 'Miriam',
    role: 'Master Lash Artist & Educator',
    rating: '4.9',
    bio:
      'Master lash artist and certified educator. Trains the next generation of YUMI lash artists and delivers some of the most-loved lashes in the city.',
    specialties: ['YUMI Educator', 'Volume Lashes', 'Lash Lift'],
    img: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/116036/medium/892c72e8-a6f9-4082-be9b-ebf3e1590ea3-Miriam-headshot.jpeg',
    book: 'https://fresha.com/p/miriam-o-3149063',
  },
];

export const REASONS = [
  {
    title: 'Two Certified Systems',
    body:
      'We\u2019re certified in both YUMI and InLei \u2014 the only studio on Burrard Street that offers both. Your artist will recommend the right one for your lashes.',
  },
  {
    title: '3,500+ Five-Star Reviews',
    body:
      'Prép has over 3,500 verified Fresha reviews and 400+ Google reviews from Vancouver clients. We don\u2019t just do good lash lifts — we\u2019re consistent.',
  },
  {
    title: 'Downtown Vancouver',
    body:
      'We\u2019re at 1305 Burrard St — steps from Burrard SkyTrain, easy street parking, walkable from the West End, Yaletown and Davie Village.',
  },
  {
    title: 'A Full-Service Studio',
    body:
      'Pair your lash lift with brow lamination, a hair appointment, or nail art. Prép is your one-stop beauty parlour on Burrard.',
  },
];

export const REVIEWS = [
  {
    quote:
      'Miriam does the best lashes I\u2019ve ever had! 10/10 recommend. So gentle and the lift is gorgeous.',
    name: 'Kat D.',
    meta: 'Fresha · March 2026',
  },
  {
    quote:
      'I came in with a Yumi lash that was in desperate need of a fix. Maryna was incredibly professional and the correction was perfect. My lashes look better than ever.',
    name: 'Paola O.',
    meta: 'Fresha · March 2026',
  },
  {
    quote:
      'Roselyn always gives my brows and lashes the best care and attention. Highly recommend her if you\u2019re looking for a true specialist in downtown.',
    name: 'Glenda C.',
    meta: 'Google · 2025',
  },
  {
    quote:
      'Lovely experience as always. The lash lift and tint is the best in Vancouver — I\u2019ve tried three other places and nothing comes close.',
    name: 'Alex G.',
    meta: 'Fresha · Oct 2023',
  },
];

export const FAQS = [
  {
    q: 'What is a lash lift and how is it different from lash extensions?',
    a: 'A lash lift curls and lifts your own natural lashes from the root — no glue, no extensions, no daily maintenance. Lash extensions, by contrast, attach synthetic fibres to each natural lash and require infills every 2–3 weeks. A lash lift at Prép lasts 8–12 weeks and leaves your lashes looking naturally longer and darker with just a tint. It\u2019s the low-maintenance alternative for Vancouver clients who want impact without upkeep.',
  },
  {
    q: 'How much does a lash lift cost in Vancouver?',
    a: 'At Prép Beauty Parlour, lash lift pricing starts at $125 for InLei Lash Filler® & Tint and $150 for YUMI Keratin Lash Lift & Tint. Both include a complimentary tint. Combo treatments with brow lamination start at $225. New clients save 15% with code PREP15. Full pricing is on this page under Pricing.',
  },
  {
    q: 'How long does a lash lift last?',
    a: 'A YUMI Keratin Lash Lift lasts 8–12 weeks depending on your lash growth cycle and aftercare routine. InLei Lash Filler® typically lasts 6–8 weeks. To maximize longevity, avoid getting lashes wet for 24 hours after the treatment and use an oil-free eye makeup remover. Most clients at Prép book every 8–10 weeks.',
  },
  {
    q: 'Are all lash artists at Prép YUMI certified?',
    a: 'Yes. Every lash artist at Prép Beauty Parlour is YUMI certified — YUMI is a French brand and certification is issued directly through the brand\u2019s training program. Our artists Roselyn, Maryna and Miriam are also certified in InLei Lash Filler® (Italy). Miriam is additionally a YUMI-certified educator. No lash lift at Prép is performed by an uncertified artist.',
  },
  {
    q: 'Can I get a lash lift if I have sensitive eyes?',
    a: 'Yes — and for sensitive eyes, we recommend InLei Lash Filler® over YUMI. InLei\u2019s formula is gentler and conditioning-focused, making it ideal for reactive skin or fragile lashes. We recommend a patch test if you have a history of severe eye allergies. Call us at 604-764-6452 or mention your sensitivity when booking and your artist will advise you at your consultation.',
  },
  {
    q: 'How do I prepare for a lash lift appointment?',
    a: 'Arrive with clean, makeup-free lashes — no mascara, no lash serum, and no eyelash extensions (these must be removed at least 2 weeks before). Avoid curling your lashes the day before. Remove contact lenses before the appointment. If you wear glasses, bring them — you\u2019ll need them right after. The full appointment is 75 minutes, so plan accordingly.',
  },
  {
    q: 'Where is Prép Beauty Parlour located?',
    a: 'We\u2019re at 1305 Burrard Street, Vancouver, BC V6Z 1Z7 — in the West End, steps from Burrard SkyTrain Station (3-minute walk) and walkable from Yaletown, Davie Village and Coal Harbour. Street parking is available on Burrard and side streets. Call 604-764-6452 or book online at lashliftvancouver.ca.',
  },
  {
    q: 'What is the aftercare for a lash lift?',
    a: 'For the first 24 hours after your lash lift: keep lashes dry — no water, steam, saunas, or swimming. Avoid touching or rubbing your eyes. Don\u2019t sleep face-down. After 24 hours, use an oil-free cleanser around your eyes to preserve the lift. A nourishing lash serum can help extend longevity. Our artists provide a full aftercare card at every appointment.',
  },
  {
    q: 'Can I get a lash lift if I\u2019m pregnant?',
    a: 'We recommend consulting your doctor or midwife first, as lash lift solutions contain perming agents that some practitioners advise avoiding in the first trimester. Many of our clients safely receive lash lifts in the second and third trimester with their healthcare provider\u2019s approval. We use InLei Lash Filler® for expectant clients when approved, as its formula is gentler. Please let us know when booking.',
  },
  {
    q: 'Does a lash lift work on short or straight lashes?',
    a: 'Yes — lash lifts work best on straight, downward-pointing or naturally short lashes. The lift creates significant visible curl and lift even on lashes that have never held a curl. YUMI is particularly effective on fine or straight Asian lashes. The only lashes unsuitable for a lift are lashes shorter than 4mm — your artist will assess this at your consultation.',
  },
  {
    q: 'What is the difference between YUMI and InLei lash lift?',
    a: 'Both are premium lash lift systems offered at Prép. YUMI (France, $150) uses a keratin-infused formula that lifts, strengthens and conditions simultaneously — ideal for all lash types and delivers the most dramatic lift. InLei Lash Filler® (Italy, $125) is a filler-formula lift that adds volume and nourishment — gentler and better suited for fragile, over-processed or shorter lashes. Your artist will recommend the right one at your consultation.',
  },
  {
    q: 'How do I book a lash lift at Prép Beauty Parlour?',
    a: 'Book online in under 60 seconds at lashliftvancouver.ca or directly on Fresha. Choose your artist — Roselyn, Maryna or Miriam — and your preferred treatment. New clients save 15% with code PREP15. You can also call or text 604-764-6452 or email info@prepbeautyparlour.com. Walk-ins are welcome between bookings but availability is not guaranteed.',
  },
];

export const IMAGES = {
  hero: 'https://customer-assets.emergentagent.com/job_brow-lash-van/artifacts/hwlxskah_Best-YUMI-lash-lift-vancouver.jpeg',
};

// Google integration
export const GOOGLE = {
  // Embedded Google Map iframe URL for 1305 Burrard Street, Vancouver
  mapEmbed:
    'https://www.google.com/maps?q=Pr%C3%A9p+Beauty+Parlour,+1305+Burrard+Street,+Vancouver,+BC&output=embed&hl=en&z=16',
  // Public Google Business Profile link (Google Reviews / GBP) — verified from
  // prepbeautyparlour.com. Visitors land on the GBP and can read or write a review.
  reviewsUrl: 'https://g.co/kgs/v3knzhy',
  writeReviewUrl: 'https://g.co/kgs/v3knzhy',
  searchUrl: 'https://www.google.com/search?q=Pr%C3%A9p+Beauty+Parlour+Vancouver',
  rating: '4.7',
  reviewCount: '400+',
};
export const VIDEOS = {
  hero: '/videos/02-lift-tint.mp4',
  heroPoster: '/videos/02-lift-tint.jpg',
  gallery: [
    {
      id: 'best-yumi',
      src: '/videos/01-yumi-lift.mp4',
      poster: '/videos/01-yumi-lift.jpg',
      title: 'The YUMI Lift',
      caption: 'A closer look at the lifted, conditioned finish.',
    },
    {
      id: 'best-yumi-copy',
      src: '/videos/02-lift-tint.mp4',
      poster: '/videos/02-lift-tint.jpg',
      title: 'Lift + Tint',
      caption: 'YUMI Keratin Lash Lift with a complimentary tint.',
    },
    {
      id: 'top-rated',
      src: '/videos/03-top-rated.mp4',
      poster: '/videos/03-top-rated.jpg',
      title: 'Top-Rated in Vancouver',
      caption: 'Real client results from the studio on Burrard.',
    },
    {
      id: 'prep-yumi',
      src: '/videos/04-prep-yumi.mp4',
      poster: '/videos/04-prep-yumi.jpg',
      title: 'Inside Prép',
      caption: 'A moment from a lash lift session at Prép Beauty Parlour.',
    },
  ],
};
